import { create } from "zustand";

interface WriteErrorState {
  message: string | null;
  /**
   * Bumped on every `show`. The notice keys off it so an identical repeat
   * message still replays its entrance and re-announces to screen readers —
   * without it, clicking a failing button twice would look like nothing
   * happened the second time.
   */
  seq: number;
  show: (message: string) => void;
  dismiss: () => void;
}

/**
 * The one write-failure message on screen. Deliberately a single slot rather
 * than a queue: a newer failure replaces the current one, so a burst of them
 * can't stack into a wall of notices (WEB-3319).
 */
export const useWriteErrorStore = create<WriteErrorState>((set) => ({
  message: null,
  seq: 0,
  show: (message) => set((s) => ({ message, seq: s.seq + 1 })),
  dismiss: () => set({ message: null }),
}));
